/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2021, Zumper
 * @description shortTermAvailability reducers
 */

import { nullReducer, payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CLEAR_SHORT_TERM_AVAILABILITY,
  CLEAR_VRBO_AVAILABILITY,
  ERROR_FETCHING_SHORT_TERM_AVAILABILITY,
  RECEIVE_SHORT_TERM_AVAILABILITY,
  RECEIVE_VRBO_AVAILABILITY,
} from '../constants/index'
import { default as metaReducer } from './meta'
import { vrboMetaReducer } from './vrboMeta'

const shortTermAvailabilityReducer = combineReducers({
  shortTermAvailability: handleActions(
    {
      [RECEIVE_SHORT_TERM_AVAILABILITY]: payloadReducer,
      [CLEAR_SHORT_TERM_AVAILABILITY]: nullReducer,
      [ERROR_FETCHING_SHORT_TERM_AVAILABILITY]: (state) => {
        const newState = {
          ...state,
          is_available: false,
        }

        return newState
      },
    },
    {}
  ),
  vrboAvailability: handleActions(
    {
      [RECEIVE_VRBO_AVAILABILITY]: payloadReducer,
      [CLEAR_VRBO_AVAILABILITY]: () => {
        return {}
      },
    },
    {}
  ),
  meta: metaReducer,
  vrboMeta: vrboMetaReducer,
})

// eslint-disable-next-line import/no-default-export
export default shortTermAvailabilityReducer
